import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router-dom';

import { NAVIGATE_PATH as PATH } from '../helpers/constants';
import { SetPassword } from '../views/Auth/SetPassword';
import { Login } from '../views/Auth/Login';
import { InviteSamlLogin } from '../views/Auth/InviteSamlLogin';
import { ResetPassword } from '../views/Auth/ResetPassword';
import { SignUp } from '../views/Auth/SignUp';
import Invite from '../views/Auth/Invite';
import PastClasses from '../views/Dashboard/PastClasses';
import UpcomingClasses from '../views/Dashboard/UpcomingClasses';
import PrivateCourses from '../views/Library/PrivateCourses';
import PublicCourses from '../views/Library/PublicCourses';
import CompanySettings from '../views/Settings/CompanySettings';
import { NavbarLayout } from './common/NavbarLayout';
import PublicCourse from '../views/Library/PublicCourse';
import CheckoutSummary from '../views/Checkout/CheckoutSummary';
import FirstCheckoutStep from '../views/Checkout/FirstCheckoutStep';
import CheckoutThanks from '../views/Checkout/CheckoutThanks';
import ProfileSettings from '../views/Settings/ProfileSettings';
import SecondCheckoutStep from '../views/Checkout/SecondCheckoutStep';
import AnonymousRoute from './routes/AnonymousRoute';
import RootRoute from './routes/RootRoute';
import CheckoutLogin from '../views/Checkout/CheckoutLogin';
import CheckoutGuest from '../views/Checkout/CheckoutGuest';
import ProgramInvites from '../views/Manage/ProgramInvites';
import DashboardCalendarView from '../views/Dashboard/DashboardCalendarView';
import LibraryCalendarView from '../views/Library/LibraryCalendarView';
import Impersonate from '../views/Auth/Impersonate';
import OpsCalendar from '../views/Admin/OpsCalendar';
import OpsClasses from '../views/Admin/OpsClasses';
import OpsClassEditor from '../views/Admin/OpsClassEditor';
import OpsAssignments from '../views/Admin/OpsAssignments';
import OpsRegistrations from '../views/Admin/OpsRegistrations';
import OpsContacts from '../views/Admin/OpsContacts';
import OpsContactEditor from '../views/Admin/OpsContactEditor';
import OpsCatalogue from '../views/Admin/OpsCatalogue';
import OpsTrainer from '../views/Admin/OpsTrainer';
import OpsPrograms from '../views/Admin/OpsPrograms';
import OpsCases from '../views/Admin/OpsCases';
import OpsAccounts from '../views/Admin/OpsAccounts';
import OpsAccountView from '../views/Admin/OpsAccountView';
import OpsComms from '../views/Admin/OpsComms';
import OpsEvals from '../views/Admin/OpsEvals';
import OpsHome from '../views/Admin/OpsHome';
import OpsHubspot from '../views/Admin/OpsHubspot';
import OpsCalendarSync from '../views/Admin/OpsCalendarSync';
import OpsSync from '../views/Admin/OpsSync';
import OpsInstructors from '../views/Admin/OpsInstructors';
import OpsReports from '../views/Admin/OpsReports';
import OpsRunBoard from '../views/Admin/OpsRunBoard';
import OpsLayout from './routes/OpsLayout';
import CustomerAdminLayout from './routes/CustomerAdminLayout';
import TeachingLayout from './routes/TeachingLayout';
import MyClasses from '../views/Teaching/MyClasses';
import RunSheet from '../views/Teaching/RunSheet';
import AdminHome from '../views/CustomerAdmin/Home';
import AdminPrograms from '../views/CustomerAdmin/Programs';
import AdminEvents from '../views/CustomerAdmin/Events';
import AdminPublicClasses from '../views/CustomerAdmin/PublicClasses';
import AdminRegistrations from '../views/CustomerAdmin/Registrations';
import AdminEvaluations from '../views/CustomerAdmin/Evaluations';
import AdminTickets from '../views/CustomerAdmin/Tickets';
import AdminRequestCourse from '../views/CustomerAdmin/RequestCourse';
import BookSlot from '../views/Public/BookSlot';
// import PendingInvites from '../views/Members/PendingInvites';
// import TeamMembers from '../views/Members/TeamMembers';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootRoute />}>
      <Route path={PATH.setPassword} element={<SetPassword />} />
      <Route path={PATH.impersonate} element={<Impersonate />} />
      <Route path={PATH.bookSlot} element={<BookSlot />} />
      <Route element={<AnonymousRoute />}>
        <Route path={PATH.login} element={<Login />} />
        <Route path={PATH.inviteSamlLogin} element={<InviteSamlLogin />} />
        <Route path={PATH.signUp} element={<SignUp />} />
        <Route path={PATH.inviteParam} element={<SignUp />} />
        <Route path={PATH.resetPassword} element={<ResetPassword />} />
        <Route path={PATH.createPassword} element={<ResetPassword create />} />
        <Route path={PATH.checkoutLogin} element={<CheckoutLogin />} />
      </Route>
      <Route element={<NavbarLayout />}>
        <Route path={PATH.inviteQuery} element={<Invite />} />
        <Route path={PATH.upcomingClasses} element={<UpcomingClasses />} />
        <Route path={PATH.pastClasses} element={<PastClasses />} />
        <Route path={PATH.publicCourses} element={<PublicCourses />} />
        <Route path={PATH.publicCourse} element={<PublicCourse />} />
        <Route path={PATH.privateCourses} element={<PrivateCourses />} />
        <Route path={PATH.profileSettings} element={<ProfileSettings />} />
        <Route path={PATH.companySettings} element={<CompanySettings />} />
        <Route path={PATH.companyInfo} element={<CompanySettings />} />
        <Route path={PATH.managePrograms} element={<ProgramInvites />} />
        <Route path={PATH.checkoutSummary} element={<CheckoutSummary />} />
        <Route path={PATH.checkoutGuest} element={<CheckoutGuest />} />
        <Route path={PATH.checkoutThanks} element={<CheckoutThanks />} />
        <Route path={PATH.firstCheckoutStep} element={<FirstCheckoutStep />} />
        <Route
          path={PATH.secondCheckoutStep}
          element={<SecondCheckoutStep />}
        />
        <Route
          path={PATH.dashboardCalendar}
          element={<DashboardCalendarView />}
        />
        <Route path={PATH.libraryCalendar} element={<LibraryCalendarView />} />
        {/*<Route path={PATH.teamMembers} element={<TeamMembers />} />*/}
        {/*<Route path={PATH.pendingInvites} element={<PendingInvites />} />*/}
      </Route>
      <Route element={<OpsLayout />}>
        <Route path="/ops" element={<OpsHome />} />
        <Route path={PATH.opsCalendar} element={<OpsCalendar />} />
        <Route path={PATH.opsClasses} element={<OpsClasses />} />
        <Route path={PATH.opsClassNew} element={<OpsClassEditor />} />
        <Route path={PATH.opsClassEdit} element={<OpsClassEditor />} />
        <Route path={PATH.opsAssignments} element={<OpsAssignments />} />
        <Route path={PATH.opsRegistrations} element={<OpsRegistrations />} />
        <Route path={PATH.opsContacts} element={<OpsContacts />} />
        <Route path={PATH.opsContactNew} element={<OpsContactEditor />} />
        <Route path={PATH.opsContactEdit} element={<OpsContactEditor />} />
        <Route path={PATH.opsCatalogue} element={<OpsCatalogue />} />
        <Route path={PATH.opsTrainer} element={<OpsTrainer />} />
        <Route path={PATH.opsPrograms} element={<OpsPrograms />} />
        <Route path={PATH.opsCases} element={<OpsCases />} />
        <Route path={PATH.opsAccounts} element={<OpsAccounts />} />
        <Route path={PATH.opsAccountView} element={<OpsAccountView />} />
        <Route path={PATH.opsComms} element={<OpsComms />} />
        <Route path={PATH.opsEvals} element={<OpsEvals />} />
        <Route path={PATH.opsSync} element={<OpsSync />} />
        <Route path={PATH.opsHubspot} element={<OpsHubspot />} />
        <Route path={PATH.opsCalendarSync} element={<OpsCalendarSync />} />
        <Route path={PATH.opsInstructors} element={<OpsInstructors />} />
        <Route path={PATH.opsReports} element={<OpsReports />} />
        <Route path={PATH.opsRunBoard} element={<OpsRunBoard />} />
      </Route>
      <Route element={<CustomerAdminLayout />}>
        <Route path={PATH.adminHome} element={<AdminHome />} />
        <Route path={PATH.adminPrograms} element={<AdminPrograms />} />
        <Route path={PATH.adminEvents} element={<AdminEvents />} />
        <Route
          path={PATH.adminPublicClasses}
          element={<AdminPublicClasses />}
        />
        <Route
          path={PATH.adminRegistrations}
          element={<AdminRegistrations />}
        />
        <Route path={PATH.adminEvaluations} element={<AdminEvaluations />} />
        <Route path={PATH.adminTickets} element={<AdminTickets />} />
        <Route
          path={PATH.adminRequestCourse}
          element={<AdminRequestCourse />}
        />
      </Route>
      <Route element={<TeachingLayout />}>
        <Route path={PATH.teaching} element={<MyClasses />} />
        <Route path={PATH.teachingClass} element={<RunSheet />} />
      </Route>
      <Route path={PATH.any} element={<Navigate to={PATH.upcomingClasses} />} />
    </Route>,
  ),
);

export const Routes = () => {
  return <RouterProvider router={router} />;
};
